import { __assign } from "tslib";
import React, { useContext, useMemo } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { BiEventType, BiDataHook } from '../../../biLogger/constants';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { NotificationType } from '../../../Notifications';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import { GlinteractionContext } from '../../_partials/Glinteraction';
import FavingIcon from '../../../FaveButton/FavingIcon';
import { useKeyDown } from '../../../utils/hooks/useKeyDown';
function getBiData(deviation, isFavourite, isCollectionPanelOpen) {
    if (isCollectionPanelOpen) {
        return;
    }
    return {
        evid: isFavourite ? BiEventType.THUMB_CLICK_UNFAVE : BiEventType.THUMB_FAVE,
        creatorid: get(deviation, 'author.useridUuid'),
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
    };
}
var FavouriteButton = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType, onToggleCollectionPanel = _a.onToggleCollectionPanel, onChangeFave = _a.onChangeFave, isCollectionPanelOpen = _a.isCollectionPanelOpen;
    var t = useTranslation().t;
    var shouldGlint = useContext(GlinteractionContext).shouldGlint;
    var keyboardShortcute = useMemo(function () { return ({
        // ctrl-g
        g: function (event) {
            if (actionBarType === 'primary' && event.ctrlKey) {
                onToggleCollectionPanel('primary');
            }
        },
    }); }, [actionBarType, onToggleCollectionPanel]);
    useKeyDown(keyboardShortcute);
    var isFavourited = deviation.isFavourited;
    var onClick = function () {
        return onChangeFave(deviation, !isFavourited, getDeviationNotificationQueue(deviation));
    };
    return (React.createElement(ActionBarButton, { onClick: onClick, dataHook: BiDataHook.DEVIATION_FAVE_BUTTON, isRelatedPanelOpen: isCollectionPanelOpen, notificationTypes: [
            NotificationType.Collect,
            NotificationType.CollectUndo,
            NotificationType.Fave,
            NotificationType.FaveUndo,
        ], biData: getBiData(deviation, isFavourited, isCollectionPanelOpen), label: t(isFavourited ? 'actionbar.inFavourites' : 'actionbar.addToFavourites') },
        React.createElement(ActionBarIcon, { isActive: isFavourited, isGlinting: shouldGlint === 'fave' && !isCollectionPanelOpen }, function (iconProps) { return (React.createElement(FavingIcon, __assign({ deviationId: deviation.deviationId, isFavourited: deviation.isFavourited }, iconProps))); })));
};
FavouriteButton.displayName = 'FavouriteButton';
export default FavouriteButton;
//# sourceMappingURL=FavouriteButton.js.map